import { Button, Stack, Typography } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

import { PATIENTS } from '@constants/routes';

import { useSession } from '@hooks/useSession';

import { formatName } from '@utils/format';

const messages = defineMessages({
  editParameters: {
    id: 'patientOverview.header.editParameters',
    defaultMessage: 'Edit Parameters',
  },
});

interface HeaderProps {
  id: string;
}

export default function Header({ id }: HeaderProps) {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const name = formatName(activeProfile?.first_name, activeProfile?.last_name);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent={{ xs: 'center', sm: 'space-between' }}
      my={2}
    >
      <Typography variant="h5">{name}</Typography>

      <Button
        onClick={() => {
          navigate(`${PATIENTS}${id}/parameters`);
        }}
        size="small"
        startIcon={<Icon name="pencil" type="fas" />}
        sx={{ borderRadius: '29px', border: 'none' }}
        variant="outlined"
      >
        {formatMessage(messages.editParameters)}
      </Button>
    </Stack>
  );
}
